export const spotListAreaStyleProps = {
    backgroundColor: {
        base: 'gray.50',
        mobileXL: 'unset',
        desktop: 'gray.50',
    },
    borderRadius: '8px',
    maxHeight: {
        base: '24.3rem',
        tablet: '24rem',
        mobileXL: '18rem',
        desktop: '44.5rem',
    },
    minWidth: {desktop: '25rem', base: '22.8rem'},
    paddingY: {desktop: '.5rem', mobileXL: 'unset', base: '.125rem'},
    paddingX: {desktop: '2rem', mobileXL: 'unset', base: '1rem'},
    borderBottomWidth: {desktop: '1px', mobileXL: 'none', base: '1px'},
    borderBottomStyle: {desktop: 'solid', mobileXL: 'unset', base: 'solid'},
    borderBottomColor: {desktop: 'accent', mobileXL: 'none', base: 'accent'},
};

export const spotListTitleStyleProps = {
    display: 'flex',
    justifyContent: {desktop: 'left', mobileXL: 'center', base: 'left'},
    paddingBottom: {desktop: '1rem', mobileXL: '1rem', base: '.5rem'},
    paddingTop: {desktop: '1rem', mobileXL: 'auto', base: '.5rem'},
};

export const spotListStyleProps = {
    display: 'flex',
    justifyContent: {desktop: 'unset', mobileXL: 'space-around', base: 'unset'},
    alignItems: {desktop: 'center', base: 'unset'},
    flexDirection: {desktop: 'column', mobileXL: 'row', base: 'column'},
    minWidth: {desktop: '100%'},
};

export const spotListCardStyleProps = {
    padding: 'none',
    height: {
        base: '9.5rem',
        mobileXL: '19rem',
        desktop: '11rem',
    },
    minWidth: {
        desktop: '100%',
        tablet: 'unset',
        mobileXL: '11rem',
        base: '100%',
    },
    maxWidth: {desktop: '23rem', tablet: '14.5rem', mobileXL: '16.5rem'},
    marginBottom: {base: '1rem', mobileXL: 'none', desktop: '1rem'},
};

export const imageStyleProps = {
    borderTopRadius: '8px',
    borderBottomRadius: {desktop: '8px', mobileXL: 'unset', base: '8px'},
    width: {
        desktop: '5rem',
        tablet: '14.5rem',
        mobileXL: '16.5rem',
        base: '5rem',
    },
    height: {
        desktop: '5rem',
        tablet: '10rem',
        mobileXL: '10rem',
        base: '5rem',
    },
    marginTop: {
        desktop: '1.25rem',
        mobileXL: 'unset',
        base: '1.25rem',
    },
    marginX: {
        desktop: '1rem',
        mobileXL: 'unset',
        base: '1rem',
    },
};

export const tagStyleProps = {
    display: 'flex',
    flexDirection: 'row',
    marginX: '1rem',
    justifyContent: 'center',
    alignItems: 'center',
    paddingY: '.125rem',
    paddingX: '.5rem',
    whiteSpace: 'nowrap',
    backgroundColor: 'yellow.100',
    width: '4.45rem',
    height: '1.75rem',
    fontSize: '.75rem',
    borderRadius: '8px',
    marginTop: '1rem',
};

export const spotDetailsStyleProps = {
    position: 'relative',
    left: {desktop: '7.75rem', mobileXL: '1rem', base: '7rem'},
    marginTop: {desktop: '1.25rem', mobileXL: '1rem', base: '1.25rem'},
};

export const spotNameStyleProps = {
    minWidth: {desktop: '8rem', mobileXL: 'unset', base: '5rem'},
    maxWidth: {
        desktop: '10rem',
        tablet: '9rem',
        mobileXL: '8rem',
        base: '8rem',
    },
    fontSize: {mobileXL: '1rem', base: '.75rem'},
    fontWeight: {desktop: 'bold', base: 'semibold'},
    whiteSpace: 'nowrap',
};

export const detailsButtonStyleProps = {
    border: {desktop: '1px', mobileXL: '0', base: '1px'},
    backgroundColor: {desktop: 'auto', mobileXL: 'transparent', base: 'auto'},
    textDecoration: {desktop: 'none', mobileXL: 'underline', base: 'none'},
    variant: 'secondary',
    marginTop: {desktop: '1rem', tablet: '6rem', base: '2rem'},
    paddingTop: {desktop: '.75rem', mobileXL: '1px', base: '1.5rem'},
    paddingBottom: {desktop: '.75rem', mobileXL: '1px', base: '.75rem'},
    paddingX: {desktop: '2rem', mobileXL: '1px', base: '2rem'},
    width: {desktop: 'auto', base: '9rem'},
    height: {mobileXL: 'auto', base: '2.25rem'},
};

export const priceStyleProps = {
    display: 'flex',
    flexDirection: 'column',
    marginRight: {desktop: '1rem', mobileXL: 'unset', base: '.5rem'},
    alignItems: 'end',
    marginTop: {
        desktop: '1.25rem',
        mobileXL: '1rem',
        base: '1.25rem',
    },
};

export const pulseLoaderContainerStyleProps = {
    display: 'flex',
    justifyContent: 'center',
    paddingY: {desktop: '14rem', base: '5rem'},
};
